/**
 * @file lib/questions.js
 */

export default [
  {
    question: "What is Bookmark?",
    answer:
      "Bookmark gives Internet users a central place to save their bookmarked webpages so that they can access them on any browser they wish.",
  },
  {
    question: "How can I request a new browser?",
    answer:
      "There's no need to request a new browser. All you need to do is install the Bookmark extension on the browser you wish to use, sign in to your Bookmark account on that extension, and you're good to go!",
  },
  {
    question: "Is there a mobile app?",
    answer:
      "There is no mobile app for Bookmark as of yet, but one is being worked on. Stay tuned!",
  },
  {
    question: "What about other Chromium browsers?",
    answer:
      "The Chromium engine powers several popular web browsers, including Google Chrome, Microsoft Edge, and the Chromium browser. The Bookmark extension for Google Chrome has been tested, and will work, on all Chromium-powered web browsers.",
  },
];
